import { useEffect, useState, useRef } from 'react';
import { useNavigate, Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import sharedStyles from 'styles/css/SharedStyles.module.scss';
import styles from 'styles/css/Main.module.scss';
import drawerStyles from 'styles/css/Drawer.module.scss';
import actionStyles from 'styles/css/ActionStyles.module.scss';
import Logo from 'styles/images/logo/logo512.png';
import Instagram from 'styles/images/svg/instagram.svg';
import LinkedIn from 'styles/images/svg/linkedin.svg';
import YouTube from 'styles/images/svg/youtube.svg';
import Facebook from 'styles/images/svg/facebook.svg';
import ForwardIcon from 'styles/images/svg/forward-white.svg';
import ArrowUp from 'styles/images/svg/arrow-up.svg';
import ArrowDown from 'styles/images/svg/arrow-down.svg';
import { API_ALL_CATEGORIES, USERS_LOGOUT_GET } from 'apis';
import apiRequest from 'utils/apiRequest';
import { handleChangeDataPageCategories } from 'reduxx/actions/pages/categories';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import Swal from 'sweetalert2';
import { useTranslation } from "react-i18next";
import { useLocalePath } from 'utils/useLocalePath';
import ShortHeaderWithBackBtn from 'components/root/partials/header/ShortHeaderWithBackBtn';


const Categories = () => {

    const to = useLocalePath();

    const dispatch = useDispatch();
    const navigate = useNavigate();


    const { cats } = useSelector(state => state.categories);


    useEffect(() => {
        apiCategories();
    }, []);

    const apiCategories = () => {
        apiRequest({
            dispatch,
            endpoint: API_ALL_CATEGORIES,
            method: 'post',
            data: {width: window.innerWidth},
            successMessage: null,
            onSuccess: (res) => {
                dispatch(handleChangeDataPageCategories('cats', res.categories));
            }
        });
    };


    return (
        
        <div className={sharedStyles.container} >

            <div className={[sharedStyles['container-padding']].join(' ')}>

                <ShortHeaderWithBackBtn />


                <section className={[styles['content-card'], sharedStyles.flex, sharedStyles.flexWrap, sharedStyles['gap-md'], sharedStyles['pb-[64px]']].join(' ')}>
                    {
                        cats && cats.map((cat, key) => (
                            <Link 
                                    to={to(`/category/${cat.id}`)}
                                    className={[styles['card-inner'], sharedStyles['text-primary'], sharedStyles.decorationNone].join(' ')} >
                                <div className={styles['placeholder-img']}>
                                    <img src={cat.image} alt={cat.title} />
                                </div>
                                <div className={styles.note}>
                                    <span className={sharedStyles['card-text']}>{cat.title}</span>
                                    <div className={styles['back-btn']}>
                                        <img src={ForwardIcon} width={20} />
                                    </div>
                                </div>
                            </Link>
                        ))
                    }
                </section>

            </div>

            
                

            
        </div>

    );
}

export default Categories;